export default function FrostwareLogo(props: any) {
  return (
    <>{"FrostWare"}</>
    )
}
